export default __webpack_public_path__ + "static/media/A0001.a6f241a9.png";